import { ImageSquare, FilmSlate, ChatsCircle, Newspaper, CalendarBlank, ChartLineUp } from "@phosphor-icons/react";
import { ContentCalendar } from "@/components/studio/ContentCalendar";
import { Performance } from "@/components/studio/Performance";
import { PageHeader } from "@/components/common";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { MediaMaker } from "@/components/studio/MediaMaker";
import { SocialMaker } from "@/components/studio/SocialMaker";
import { NewsletterMaker } from "@/components/studio/NewsletterMaker";

const TABS = [["images", "Images", ImageSquare], ["videos", "Videos", FilmSlate], ["social", "Social posts", ChatsCircle], ["newsletters", "Newsletters", Newspaper], ["calendar", "Calendar", CalendarBlank], ["performance", "Performance", ChartLineUp]];

export default function Studio() {
  return (
    <div data-testid="studio-page">
      <PageHeader eyebrow="M02–M07 · Marketing engine" title="Content studio"
        desc="Make on-brand images, short videos, social posts and newsletters. Copy uses only approved product claims; everything needs approval before it goes out." />
      <Tabs defaultValue="images">
        <TabsList className="mb-5 h-auto flex-wrap">
          {TABS.map(([v, l, I]) => <TabsTrigger key={v} value={v} data-testid={`studio-tab-${v}`} className="gap-1.5"><I size={16} />{l}</TabsTrigger>)}
        </TabsList>
        <TabsContent value="images"><MediaMaker kind="image" /></TabsContent>
        <TabsContent value="videos"><MediaMaker kind="video" /></TabsContent>
        <TabsContent value="social"><SocialMaker /></TabsContent>
        <TabsContent value="newsletters"><NewsletterMaker /></TabsContent>
        <TabsContent value="calendar"><ContentCalendar /></TabsContent>
        <TabsContent value="performance"><Performance /></TabsContent>
      </Tabs>
    </div>
  );
}
